import * as types from "../../actions/actionTypes";
const initialState = {
  error2Number: "",
  loading2Number: false,
  data2Number: { all_data: [], current_imprest_data: [] },

  errorCashRemain: "",
  loadingCashRemain: false,
  dataCashRemain: {},

  errorClassification: "",
  loadingClassification: false,
  dataClassification: { all_data: [], current_imprest_data: [] },

  errorPayment: "",
  loadingPayment: false,
  dataPayment: {}
};

const Dashboard = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_REQUEST:
      return { ...state, loading2Number: true, error2Number: "" };
    case types.PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_SUCCESS:
      return { ...state, data2Number: action.payLoad, loading2Number: false };
    case types.PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_FAILURE:
      return { ...state, loading2Number: false, error2Number: action.error };

    case types.PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_REQUEST:
      return { ...state, loadingCashRemain: true, errorCashRemain: "" };
    case types.PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_SUCCESS:
      return {
        ...state,
        dataCashRemain: action.payLoad,
        loadingCashRemain: false
      };
    case types.PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_FAILURE:
      return {
        ...state,
        loadingCashRemain: false,
        errorCashRemain: action.error
      };

    case types.PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_REQUEST:
      return { ...state, loadingClassification: true, errorClassification: "" };
    case types.PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        dataClassification: action.payLoad,
        loadingClassification: false
      };
    case types.PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_FAILURE:
      return {
        ...state,
        loadingClassification: false,
        errorClassification: action.error
      };

    case types.PETTY_CASHIER_DASHBOARD_GET_PAYMENT_REQUEST:
      return { ...state, loadingPayment: true, errorPayment: "" };
    case types.PETTY_CASHIER_DASHBOARD_GET_PAYMENT_SUCCESS:
      return { ...state, dataPayment: action.payLoad, loadingPayment: false };
    case types.PETTY_CASHIER_DASHBOARD_GET_PAYMENT_FAILURE:
      return { ...state, loadingPayment: false, errorPayment: action.error };

    default:
      return state;
  }
};

export default Dashboard;
